import React from 'react';
import NumberField from './NumberField';

function Adjustments({ settings, onChange }) {
  return (
    <section className="panel adjustments-panel">
      <div className="section-heading">
        <div>
          <span className="section-kicker">Financial controls</span>
          <h2>Adjustments and reserves</h2>
        </div>
      </div>

      <div className="adjustment-grid">
        <NumberField
          label="Package discount"
          value={settings.discountRate}
          onChange={(value) => onChange('discountRate', value)}
          suffix="%"
          step={0.5}
          helper="Negotiated society or volume discount"
        />
        <NumberField
          label="Contingency reserve"
          value={settings.contingencyRate}
          onChange={(value) => onChange('contingencyRate', value)}
          suffix="%"
          step={0.5}
          helper="Recommended range: 5–12%"
        />
        <NumberField
          label="Tax and fees"
          value={settings.taxRate}
          onChange={(value) => onChange('taxRate', value)}
          suffix="%"
          step={0.1}
          helper="Enter applicable tax or service fees"
        />
      </div>
    </section>
  );
}

export default Adjustments;